
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { ModalPromptComponent } from "../../../../_helpers/Modals/prompt/modal.prompt";
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from '../../../../_utils/Constants';
import { APIEntityService } from '../../_services/entity/API-entity';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: 'app-petmbinding-new-chain-creation',
  templateUrl: './petmbinding-new-chain-creation.component.html',
  styleUrls: ['./petmbinding-new-chain-creation.component.css']
})

export class PETMBindingNewChainComponent implements OnInit {
  createchainForm: FormGroup;
  tmid: any;
  tmname: any;
  peid: any;
  pename: any;
  validTm: boolean = true;

  constructor(private fb: FormBuilder, private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private router: Router,
    private _route: ActivatedRoute,
    private es: APIEntityService,
    private modalService: BsModalService
  ) {
    this._route.params.subscribe((params) => {
      this.peid = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      this.pename = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
    });
  }

  get f() { return this.createchainForm.controls; }

  ngOnInit() {
    this.createchainForm = this.fb.group({
      tmid: ['', [Validators.required]],
      tmname: ['']

    });

  }


  reset() {
    this.createchainForm.controls['tmid'].reset();
    this.createchainForm.controls['tmname'].reset();
    this.validTm = true;
  }

  getentityname(filterValue: string) {
    console.log("in filter",filterValue);
    let data = {
      TMID: filterValue,
    };

    //console.log("--------data---", data);
    this.es.gettmname(data).subscribe((r) => {
     // console.log("-----------r----", r);
      if (r.status == "success") {
        this.createchainForm.controls["tmname"].setValue(r.message);
        this.createchainForm.controls["tmname"].disable();
        this.validTm = false;
      } else {
        this.$modal.errorModal({
          title: "PE TM Binding - New Chain Creation",
          msg: r.message,
        });
        this.createchainForm.controls["tmname"].setValue('');
        this.createchainForm.controls["tmname"].disable();
        this.validTm = true;
      }    
    });
  }


  onSubmit() {

    if (this.createchainForm.invalid) {
      console.log("Invalid form: ", this.createchainForm);
      return;
    }
    else {

      this.tmid = this.createchainForm.get('tmid').value
      this.tmname = this.createchainForm.get('tmname').value

      let data = {
        PEID:this.peid,
        PENAME: this.pename,
        TMID: this.tmid,
        TMNAME: this.tmname
      }

      this.es.petmbindingcreatechain(data)
        .subscribe(r => {
          //console.log("r ----> ", r);
          if (r.status == "Success") {
            this.$modal.successModal({
              title: 'PE TM Binding Create New Chain',
              msg: 'PE TM Chain created succesfully with URN '+ r.message.URN
            });


            this.router.navigateByUrl('/petmbinding-pelist');

          }
          else {
            this.$modal.errorModal({
              title: 'PE TM Binding Create New Chain',
              msg: r.message
            });
          }
        })
      //}
    }

  }

}
